import moment from "moment"
import React, { useEffect, useState } from "react"
import { useGet } from "../../hooks/useGet"
import { BarChartMultiple } from "../../ui/charts/BarChartMultiple"
import { Loader } from "../../ui/loaders/Loader"
import { TeacherNote } from "./TeacherNote"
import { v4 } from "uuid"
import { useTranslation } from "react-i18next"
import { useLanguage } from "../../hooks/useLanguage"
import { GlobalRank } from "./GlobalRank"

export const GraphView = ({ examId, studentId }) => {
  const { t } = useTranslation()
  const url = `student/exam/report?student_id=${studentId}&exam_id=${examId}`
  const { loading, response, error } = useGet(url)
  const [performanceLabels, setPerfomaceLabels] = useState(() => [])
  const [performaceDatasets, setPerformanceDatasets] = useState(() => [])
  const [examResults, setExamResults] = useState()
  const [classDatasets, setClassDatasets] = useState(() => [])
  const [examGroupData, setExamGroupData] = useState()
  useEffect(() => {
    const datasets = []
    if (response?.data) {
      console.log(response.data)
      const dset = response.data.subject_performance_graph_data.datasets
      setPerfomaceLabels(response.data.subject_performance_graph_data.labels)

      Object.keys(dset).forEach((key) => {
        datasets.push({
          label: key,
          data: dset[key],
        })
      })
      const tmpClassDatasets = []
      tmpClassDatasets.push({
        label: response.data.information.student_name,
        data: [response.data.course_graph_data.total_student_point],
      })
      tmpClassDatasets.push({
        label: "total exam",
        data: [response.data.course_graph_data.total_exam_points],
      })
      tmpClassDatasets.push({
        label: "exam average",
        data: [response.data.course_graph_data.exam_average],
      })
      setClassDatasets(tmpClassDatasets)
      setPerformanceDatasets(datasets)
      setExamResults(response?.data?.student?.exam_results)
      if (response.data?.exam_group_data) {
        console.log(response.data.exam_group_data)
        setExamGroupData(response.data.exam_group_data)
      }
      if (response.data?.exam_group_data == 0) {
        console.log(response.data.exam_group_data)
        setExamGroupData()
      }
    }
  }, [response])
  return (
    <div>
      {loading && <Loader message={`Please wait`} />}
      {response?.data.exams.length > 0 && response?.data.exams[0].exam_note && (
        <TeacherNote notes={response?.data.exams[0].exam_note.notes} />
      )}
      <table className="table table-striped mt-3">
        <thead>
          {examGroupData?.name && (
            <tr className="alert alert-primary">
              <th colSpan={4} className="text-left">
                <GlobalRank examGroupData={examGroupData} />
              </th>
            </tr>
          )}
          <tr>
            <th>{response?.data?.information?.course}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("student_result")}</th>
            <td>{response?.data?.student_total}</td>
            <th>{t("class_average")}</th>
            <td>{response?.data.class_avg}</td>
          </tr>
          {/* <tr>
              <th>Grade</th>
              <td>{response?.data.information.level}</td>
              <th>Course</th>
              <td>{response?.data.information.course}</td>
            </tr> */}
          <tr>
            <th>{t("rank_in_class")}</th>
            <td>{response?.data.rank_in_class}</td>
            <th>{t("rank_in_classes")}</th>
            <td>{response?.data.rank_in_classes}</td>
          </tr>
          <tr>
            <th>{t("exam_definition")}</th>
            <td>{response?.data.information.exam_definition}</td>
            <th>{t("exam_date")}</th>
            <td>{moment(response?.data.information.exam_date).format("DD-MM-YYYY")}</td>
          </tr>
          {/* <tr>
              <th>{t('teacher')}</th>
              <td colSpan={3} style={{textTransform:'capitalize'}}>{response?.data.exams[0].user.name} {response?.data.exams[0].user.surname}</td>
            </tr> */}
        </tbody>
      </table>

      <div className="row">
        {/* <div className="col-lg-6">
          <div className="card">
            <div className="card-header">
              {response?.data.information.course}
            </div>
            <BarChartMultiple
              height="800px"
              labels={[response?.data.information.exam_definition]}
              datasets={classDatasets}
              indexAxis="y"
            />
          </div>
        </div> */}
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">Performace over Subjects %</div>
            <BarChartMultiple height="800px" labels={performanceLabels} datasets={performaceDatasets} indexAxis="y" />
          </div>
        </div>
      </div>

      {response?.data.performance_below_subjects.length > 0 && (
        <div className="card mt-3">
          <div className="card-header bg-danger fw-bold text-white">{t("student_below_performance_graph")}</div>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Subject</th>
              </tr>
            </thead>
            <tbody>
              {response?.data.performance_below_subjects.map((subject) => {
                return (
                  <tr key={v4()}>
                    <td>{subject}</td>
                  </tr>
                )
              })}
              <tr></tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
